import { getDefaultHocKy, getDefaultNamHoc } from "../../../utils/getDefaultValue";
import { ICongThucTinhDiemActionTypes } from "../../action-types/category/ICongThucTinhDiemActions";
import { ICongThucTinhDiemReducer } from "../../reducer-model/category/ICongThucTinhDiemReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";


const inniState: ICongThucTinhDiemReducer = {
    status: eReducerStatusBase.is_not_initialization,
    congThucTinhDiems: [],
    filter: {
        id_he: 0,
    },
    congThucLopHocPhanEditModel: {
        isShowModal: false,
        ky_dang_ky: 0,
        nam_hoc: getDefaultNamHoc(),
        hoc_ky: getDefaultHocKy(),
        lopTinChis: [],
    },
}

export const congThucTinhDiemReducer = (
    state: ICongThucTinhDiemReducer = inniState,
    action: ICongThucTinhDiemActionTypes
): ICongThucTinhDiemReducer => {
    switch (action.type) {
        case "CONG_THUC_TINH_DIEM_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "CONG_THUC_TINH_DIEM_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                congThucTinhDiems: action.payload,
            };
        case "CONG_THUC_TINH_DIEM_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CONG_THUC_TINH_DIEM_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                congThucTinhDiemEditing: action.payload
            };
        case "CONG_THUC_TINH_DIEM_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            };
        case "CONG_THUC_TINH_DIEM_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "CONG_THUC_TINH_DIEM_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false
            };
        case "CONG_THUC_TINH_DIEM_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CONG_THUC_TINH_DIEM_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "CONG_THUC_TINH_DIEM_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            };
        case "CONG_THUC_TINH_DIEM_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "CONG_THUC_TINH_DIEM_CHANGE_SELECTED_IDS":
            return {
                ...state,
                congThucSelected: action.payload
            };
        case "CONG_THUC_TINH_DIEM_CHANGE_FILTER":
            return {
                ...state,
                filter: action.payload
            };
        case "CONG_THUC_TINH_DIEM_CHANGE_CONG_THUC_LOP_HOC_PHAN_MODAL":
            return {
                ...state,
                congThucLopHocPhanEditModel: {
                    ...state.congThucLopHocPhanEditModel,
                    ...action.payload,
                }
            };
        case "CONG_THUC_TINH_DIEM_LOAD_LOP_TIN_CHI_START":
            return {
                ...state,
                congThucLopHocPhanEditModel: {
                    ...state.congThucLopHocPhanEditModel,
                    status: eReducerStatusBase.is_loading,
                }
            };
        case "CONG_THUC_TINH_DIEM_LOAD_LOP_TIN_CHI_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                congThucLopHocPhanEditModel: {
                    ...state.congThucLopHocPhanEditModel,
                    lopTinChis: action.payload,
                    status: eReducerStatusBase.is_completed,
                }
            };
        case "CONG_THUC_TINH_DIEM_LOAD_LOP_TIN_CHI_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                congThucLopHocPhanEditModel: {
                    ...state.congThucLopHocPhanEditModel,
                    status: eReducerStatusBase.is_completed,
                }
            };
        case "CONG_THUC_TINH_DIEM_SAVE_CONG_THUC_LOP_HOC_PHAN_START":
            return {
                ...state,
                congThucLopHocPhanEditModel: {
                    ...state.congThucLopHocPhanEditModel,
                    status: eReducerStatusBase.is_saving,
                }
            };
        case "CONG_THUC_TINH_DIEM_SAVE_CONG_THUC_LOP_HOC_PHAN_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                congThucLopHocPhanEditModel: {
                    ...state.congThucLopHocPhanEditModel,
                    isShowModal: false,
                    status: eReducerStatusBase.is_need_reload,
                }
            };
        case "CONG_THUC_TINH_DIEM_SAVE_CONG_THUC_LOP_HOC_PHAN_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                congThucLopHocPhanEditModel: {
                    ...state.congThucLopHocPhanEditModel,
                    status: eReducerStatusBase.is_completed,
                }
            };
        default:
            return state;
    }
}